import {
  createContext,
  ReactElement,
  useContext,
  useEffect,
  useState,
} from 'react';

export interface LocationContextType {
  location: Location | null;
  href: string;
}

const HREF_DEFAULT = 'https://blumint.com';

const defaultState: LocationContextType = {
  location: null,
  href: HREF_DEFAULT,
};

const LocationContext = createContext(defaultState);

export function useLocation() {
  return useContext(LocationContext);
}

export type LocationProviderProps = {
  children: ReactElement;
};

export function LocationProvider({ children }: LocationProviderProps) {
  const [location, setLocation] = useState<Location | null>(null);

  const popLocation = () => {
    setLocation(window.location);
  };
  useEffect(() => {
    popLocation();
    window.addEventListener('popstate', popLocation);
    return () => {
      window.removeEventListener('popstate', popLocation);
    };
  }, []);

  return (
    <LocationContext.Provider
      value={{
        location,
        href: location?.href || HREF_DEFAULT,
      }}
    >
      {children}
    </LocationContext.Provider>
  );
}
